import { Control } from '@yleisradio/areena-types';
import { useCookieConsent } from 'contexts/CookieConsentContext';
import { useEffect, useRef } from 'react';
import { usePlayerState } from 'contexts/PlayerStateContext';
import { usePrimaryPlayer } from 'components/Player/usePrimaryPlayer';

export function isAutoplayEnabled(): boolean {
  if (typeof window !== 'undefined') {
    const { location } = window;
    const isAutoplayParameterSet = /[?#&]autoplay=true\b/.test(
      location.search + location.hash
    );
    const isSeekParameterSet = /[?&]seek=\d+\b/.test(location.search);
    return isAutoplayParameterSet || isSeekParameterSet;
  }
  return false;
}

export function useAutoplay(primaryPlayControl: Control | undefined): void {
  const hasAutoplayBeenTriggeredRef = useRef<boolean>(false);
  const cookieConsent = useCookieConsent();
  const isCookieConsentGiven = !!cookieConsent;
  const { setActivePlayer } = usePlayerState();
  const primaryPlayer = usePrimaryPlayer(primaryPlayControl);

  useEffect(() => {
    const hasAutoplayBeenTriggered = hasAutoplayBeenTriggeredRef.current;

    if (
      isAutoplayEnabled() &&
      primaryPlayer &&
      !hasAutoplayBeenTriggered &&
      isCookieConsentGiven
    ) {
      setActivePlayer(primaryPlayer);
      hasAutoplayBeenTriggeredRef.current = true;
    }
  }, [isCookieConsentGiven, primaryPlayer, setActivePlayer]);
}
